import { h } from 'preact'
export default function NoResults({ title, text }) {
    return (
        <div class="no-results">
            <span class="no-results__title">{title && (title)}</span>
            <span class="no-results__text">{text && (text)}</span>
        </div>
    )
}